import { Pipe, PipeTransform } from '@angular/core';
import {SchoolFilterType} from '../model/entity-profile';
import {IntegrationState} from '../../views/admin/application-settings/models/integration-state.model';

@Pipe({
    name: 'ngcSchoolStatus',
    pure: false
})
export class SchoolStatusPipe implements PipeTransform {

    transform(items: any[], filter?: SchoolFilterType): any[] {
        if (!items || !filter) {
            return items;
        }
        return items.filter((item: any) => this.applyFilter(item, filter));
    }

    applyFilter(school: any, filter: SchoolFilterType) {
        switch (filter) {
            case SchoolFilterType.ACTIVE:
                return (school.status === IntegrationState.SYNCED);
            case SchoolFilterType.PENDING:
                return (school.status === IntegrationState.PENDING);
            case SchoolFilterType.WITHERROR:
                return (school.status === IntegrationState.EXPIRED);
            case SchoolFilterType.INACTIVE:
                return ([IntegrationState.SYNCED, IntegrationState.EXPIRED,
                    IntegrationState.PENDING, IntegrationState.SUSPENDED,
                    IntegrationState.SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD,
                    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT,
                    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_OTHER
                ].indexOf(school.status) === -1);
            default:
                return true;
        }
    }
}
